import { CityInterface } from '../interface/cityInterface.ts';
import api from '../instance/axios_instance.ts';
const CityApi = async (): Promise<CityInterface> => {
    
    try {

        const response = await api.get<CityInterface>('/city');
        return response.data;

    } catch (err) {
        console.error('Error in CityApi:', err);
        throw err;
    }
};

export default CityApi;